import { render, staticRenderFns } from "./OrderFileEditor.vue?vue&type=template&id=5318ec2c"
import script from "./OrderFileEditor.vue?vue&type=script&lang=js"
export * from "./OrderFileEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports